import  FaLocationArrow  from '@mui/icons-material/PinDrop';
import "./hero.css"
import { SparklesCore } from "../ui/Sparkles";
import grida from "../svgs/grid.svg"
import Spotlight from '../ui/Spotlight';
import TextGenerateEffect from '../ui/TextGenerateEffect';
import { useEffect } from "react";
import myLog from "../imgz/mindzlogo.png"

const Hero = ({scrollToElement}) => {
  return (
    <div className="hero">
             {/* UI: Spotlights */}
      <div>
      <Spotlight className="spotlight-white" fill="white" />
        <Spotlight className="spotlight-purple" fill="purple" />
        <Spotlight className="spotlight-blue" fill="blue" />   
           </div>

      {/* UI: Grid */}
      <div className="outer-container">
        {/* Radial gradient for the container */}
        <div className="inner-container" />
      </div>

      <div className="company-container">
          <div className="secondname">
              <h2 className="welcome-text">
                Welcome to the Masters of Technology in Tanzania
              </h2>
              
              {/*
               <TextGenerateEffect className="gentextone" text="Mastermindz Tech" /> 
              */}
              <img src={myLog} alt="" className="gentextone2" />
              <div class="gradient-container">
      
        <div class="gradient-1"></div>
        <div class="gradient-2"></div>
        <div class="gradient-3"></div>
        <div class="gradient-4"></div>

      
        <SparklesCore
            background="transparent"
            minSize={0.4}
            maxSize={1}
            particleDensity={1200}
            className="w-full h-full"
            particleColor="#FFFFFF"
        />
              </div>

              <TextGenerateEffect
                className="textgen2"
                text="Pioneering innovation in software development. We specialize in creating cutting-edge Logos, website apps, mobile apps, and desktop apps, delivering seamless digital experiences that drive success"
              />

              
                <div className="buttWork" onClick={()=> scrollToElement("project")}  >
                  <h2 className="showwork" >Show our work</h2>
                  <div className="locationIcon" ><FaLocationArrow fontSize="inherit"/></div>
                </div>
                        
              
        </div>
      </div>
    </div>
  );
};

export default Hero;
